import { atom, getDefaultStore, useAtom } from 'jotai';
import { Singleton } from 'Core_Helpers/Singleton';
import { IStateStore } from 'Core_Helpers/IStateStore';
import reduxStore from 'Core_Redux/store';

const ALLOWED_NETWORK_IDS = [23100];
const DISPLAY_START_DATE = new Date('2025-11-17T00:00:00');

export class AppMigrationTakeoverModalModuleStore extends Singleton implements IStateStore {
  private atomStore = getDefaultStore();
  private isOpenAtom;

  constructor() {
    super();
    this.isOpenAtom = atom(false);
  }

  public Use = () => {
    useAtom(this.isOpenAtom);
    return this;
  };

  public get IsOpen(): any {
    return this.atomStore.get(this.isOpenAtom);
  }

  public open() {
    this.atomStore.set(this.isOpenAtom, true);
  }

  private isAllowedNetworkId(): boolean {
    const userState = reduxStore.store.getState().user;
    const primaryNetworkId = userState?.syncUser?.primaryNetworkId;

    if (!primaryNetworkId) {
      return false;
    }

    return ALLOWED_NETWORK_IDS.includes(primaryNetworkId);
  }

  private isWithinDateRange(): boolean {
    const now = new Date();
    // Display from 11/17/2025 onwards
    return now >= DISPLAY_START_DATE;
  }

  public readyForDisplay(): boolean {
    // This modal should always display once the date is reached and network ID matches
    // Users cannot dismiss it
    return this.isAllowedNetworkId() && this.isWithinDateRange();
  }
}
